import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqList = ({ faqs = [] }) => (
  <Accordion type="single" collapsible className="border-t border-violet-200" data-testid="faq-list">
    {faqs.map((f, i) => (
      <AccordionItem key={i} value={`f${i}`} className="border-b border-violet-200">
        <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left text-base font-bold text-[#13052A] hover:no-underline sm:text-lg">{f.q}</AccordionTrigger>
        <AccordionContent className="pb-6 text-base leading-relaxed text-slate-600">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
